<template>
  <!-- 活动云相册管理: 客服在小程序现场上传的照片, 后台可以补传/查看/删除 -->
  <div class="activityAlbum">
    <div class="album-head">
      <h3 class="title-t">{{ activityName || "活动云相册" }}</h3>

      <!-- 开关与有效期: 相册关闭或过期后, 小程序端入口不再展示 -->
      <div class="album-setting mg-t-20">
        <span class="label">云相册开关：</span>
        <el-switch
          v-model="albumForm.is_album_open"
          :active-value="1"
          :inactive-value="2"
          @change="saveSetting"
        ></el-switch>
        <span class="label mg-l-30">可查看截止时间：</span>
        <el-date-picker
          v-model="albumForm.album_expire_time"
          type="datetime"
          placeholder="不填表示长期有效"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="saveSetting"
        >
        </el-date-picker>
        <span class="font-12 color-999 mg-l-20"
          >关闭或过了截止时间后，客户在小程序里看不到云相册入口</span
        >
      </div>

      <!-- 统计 -->
      <div class="album-count mg-t-20">
        <span>照片总数：<b>{{ countInfo.total || 0 }}</b></span>
        <span>后台上传：<b>{{ countInfo.from_cms || 0 }}</b></span>
        <span>小程序上传：<b>{{ countInfo.from_mini || 0 }}</b></span>
        <span>参与上传人数：<b>{{ countInfo.user_count || 0 }}</b></span>
      </div>
    </div>

    <div class="album-bar mg-t-20">
      <el-radio-group v-model="query.upload_source" @change="reload">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button label="1">后台上传</el-radio-button>
        <el-radio-button label="3">小程序上传</el-radio-button>
      </el-radio-group>

      <el-select
        v-model="query.order"
        class="mg-l-20"
        style="width: 140px"
        @change="reload"
      >
        <el-option label="最新在前" value="desc"></el-option>
        <el-option label="最早在前" value="asc"></el-option>
      </el-select>

      <div class="fr">
        <!-- 需求 2.3: 现场客服没电脑, 扫这个码用手机传 -->
        <el-button @click="qrShow = true">手机上传二维码</el-button>
        <el-button
          type="danger"
          plain
          :disabled="!selected.length"
          @click="batchDelete"
          >批量删除{{ selected.length ? `(${selected.length})` : "" }}</el-button
        >
        <el-upload
          class="upload-inline mg-l-10"
          action="#"
          :accept="'jpg,jpeg,png,gif'"
          :show-file-list="false"
          multiple
          :before-upload="beforeUpload"
          :http-request="httpRequest"
        >
          <el-button type="primary" :loading="uploading">上传照片</el-button>
        </el-upload>
      </div>
    </div>

    <p class="font-12 color-999 mg-t-10">
      支持 JPG / PNG / GIF，单张不超过 20MB，可一次选多张
    </p>

    <!-- 照片墙 -->
    <div class="album-list mg-t-20" v-if="list.length">
      <div
        class="album-item"
        :class="{ 'is-checked': selected.includes(item.uuid) }"
        v-for="item in list"
        :key="item.uuid"
      >
        <el-checkbox
          class="item-check"
          :value="selected.includes(item.uuid)"
          @change="toggleSelect(item.uuid)"
        ></el-checkbox>
        <el-image
          class="item-img"
          :src="item.url"
          fit="cover"
          :preview-src-list="previewList"
        ></el-image>
        <div class="item-info">
          <p class="ellipsis">{{ sourceText(item.upload_source) }}</p>
          <p class="ellipsis color-999">
            {{ item.uploader_name || item.nick_name || "-" }}
          </p>
          <p class="color-999">{{ item.create_time }}</p>
        </div>
        <el-button type="text" class="item-del" @click="deleteOne(item)"
          >删除</el-button
        >
      </div>
    </div>
    <el-empty v-else-if="loaded" description="还没有照片"></el-empty>

    <pagination
      v-if="tableData.total"
      :total="tableData.total"
      :per_page="tableData.per_page"
      :current_page="tableData.current_page"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    />

    <div class="mg-t-30">
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>

    <!-- 手机上传二维码: 小程序码指向云相册上传页, 扫码人需具备活动工作人员权限 -->
    <el-dialog title="手机上传照片" :visible.sync="qrShow" width="420px" center>
      <div class="qr-box">
        <img v-if="qrShow" :src="uploadQrUrl" alt="上传二维码" />
        <p class="font-12 color-999 mg-t-10">
          用微信扫一扫，进入小程序直接上传现场照片
        </p>
        <p class="font-12 color-999">
          扫码的账号需要是「活动工作人员」，否则打开后会提示无上传权限
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="qrShow = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pagination from "../../../components/pagination.vue";

export default {
  name: "activityAlbum",
  components: { pagination },
  data() {
    return {
      activityUuid: "",
      activityName: "",
      albumForm: { is_album_open: 2, album_expire_time: "" },
      countInfo: {},
      query: { upload_source: "", order: "desc", page_index: 1, page_size: 24 },
      tableData: { total: 0, per_page: 24, current_page: 1 },
      list: [],
      selected: [],
      loaded: false,
      uploading: false,
      qrShow: false,
      // 一次选多张时 el-upload 会逐个回调 http-request, 这里攒够再一次性提交,
      // 避免每张都发一次保存请求
      pending: [],
      pendingTimer: null,
    };
  },
  computed: {
    previewList() {
      return this.list.map((i) => i.url);
    },
    // type=album 让后端把小程序码指向上传页, 不传就是原来的扫码签到页。
    // 必须走环境变量: img 的 src 不经过 axios 拦截器, 写死正式域名的话测试环境
    // 会去请求正式接口, 而正式还没部署 type 参数, 就会退回成签到页的码
    uploadQrUrl() {
      return `${process.env.VUE_APP_API_BASE_URL}/v1/cms/Activity/qrcode?uuid=${this.activityUuid}&type=album`;
    },
  },
  created() {
    this.activityUuid = this.$route.query.uuid || "";
    if (!this.activityUuid) {
      this.$message.error("缺少活动参数");
      return;
    }
    this.getActivity();
    this.getList();
    this.getCount();
  },
  methods: {
    headers() {
      return {
        "Content-Type": "application/json",
        "X-Access-Token": this.storage.get("__token"),
        Authorization: `Bearer ${this.storage.get("__token")}`,
      };
    },
    sourceText(v) {
      return { 1: "后台上传", 2: "手机端上传", 3: "小程序上传" }[v] || "-";
    },
    // 取活动名和相册开关的当前值
    getActivity() {
      this.axios({
        method: "get",
        headers: this.headers(),
        url: `https://time.api.boyalife.cn/v1/cms/Activity/${this.activityUuid}`,
      })
        .then((res) => {
          const d = res.data.result || {};
          this.activityName = d.name || "";
          this.albumForm.is_album_open = Number(d.is_album_open) || 2;
          this.albumForm.album_expire_time = d.album_expire_time || "";
        })
        .catch((err) => {
          this.$message.error(this.errMsg(err));
        });
    },
    getList() {
      this.axios({
        method: "get",
        headers: this.headers(),
        url: `https://time.api.boyalife.cn/v1/cms/ActivityAlbum`,
        params: {
          activity_uuid: this.activityUuid,
          upload_source: this.query.upload_source,
          order: this.query.order,
          page_index: this.query.page_index,
          page_size: this.query.page_size,
        },
      })
        .then((res) => {
          const d = res.data.result || {};
          this.list = d.data || [];
          this.tableData.total = d.total || 0;
          this.tableData.per_page = d.per_page || this.query.page_size;
          this.tableData.current_page = d.current_page || 1;
          this.loaded = true;
        })
        .catch((err) => {
          this.loaded = true;
          this.$message.error(this.errMsg(err));
        });
    },
    getCount() {
      this.axios({
        method: "get",
        headers: this.headers(),
        url: `https://time.api.boyalife.cn/v1/cms/ActivityAlbum/count`,
        params: { activity_uuid: this.activityUuid },
      })
        .then((res) => {
          this.countInfo = res.data.result || {};
        })
        .catch(() => {});
    },
    reload() {
      this.query.page_index = 1;
      this.selected = [];
      this.getList();
    },
    handleCurrentChange(v) {
      this.query.page_index = v;
      this.selected = [];
      this.getList();
    },
    handleSizeChange(v) {
      this.query.page_size = v;
      this.query.page_index = 1;
      this.selected = [];
      this.getList();
    },
    toggleSelect(uuid) {
      const i = this.selected.indexOf(uuid);
      if (i > -1) this.selected.splice(i, 1);
      else this.selected.push(uuid);
    },
    // 相册开关/有效期, 改一次存一次
    saveSetting() {
      this.axios({
        method: "put",
        headers: this.headers(),
        url: `https://time.api.boyalife.cn/v1/cms/Activity/album/${this.activityUuid}`,
        data: {
          is_album_open: this.albumForm.is_album_open,
          album_expire_time: this.albumForm.album_expire_time || "",
        },
      })
        .then(() => {
          this.$message.success("已保存");
        })
        .catch((err) => {
          this.$message.error(this.errMsg(err));
          this.getActivity(); // 存失败就把开关拨回真实值
        });
    },
    beforeUpload(file) {
      const isImg = /\.(jpg|jpeg|png|gif)$/i.test(file.name);
      if (!isImg) {
        this.$message.error(`${file.name} 不是 JPG/PNG/GIF 格式`);
        return false;
      }
      if (file.size / 1024 / 1024 > 20) {
        this.$message.error(`${file.name} 超过 20MB`);
        return false;
      }
      this.uploading = true;
      return true;
    },
    // 每张图先传文件服务拿 url, 攒齐后再一次性写库
    httpRequest(option) {
      const fd = new FormData();
      fd.append("file[]", option.file);
      this.$api.file
        .uploadFile(fd)
        .then((res) => {
          this.pending.push({
            url: res[0].url,
            file_name: option.file.name,
            file_size: Math.ceil(option.file.size / 1024), // 接口按 KB 校验
          });
          this.flushPending();
        })
        .catch((err) => {
          this.uploading = false;
          this.$message.error(this.errMsg(err));
        });
    },
    flushPending() {
      clearTimeout(this.pendingTimer);
      this.pendingTimer = setTimeout(() => {
        const photos = this.pending.splice(0);
        if (!photos.length) {
          this.uploading = false;
          return;
        }
        this.axios({
          method: "post",
          headers: this.headers(),
          url: `https://time.api.boyalife.cn/v1/cms/ActivityAlbum`,
          data: { activity_uuid: this.activityUuid, photos },
        })
          .then((res) => {
            this.uploading = false;
            this.$message.success(`已上传 ${res.data.result || photos.length} 张`);
            this.reload();
            this.getCount();
          })
          .catch((err) => {
            this.uploading = false;
            this.$message.error(this.errMsg(err));
          });
      }, 400);
    },
    deleteOne(item) {
      this.$confirm("删除后客户在小程序里将看不到这张照片，确定删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.axios({
            method: "delete",
            headers: this.headers(),
            url: `https://time.api.boyalife.cn/v1/cms/ActivityAlbum/${item.uuid}`,
          })
            .then(() => {
              this.$message.success("已删除");
              this.getList();
              this.getCount();
            })
            .catch((err) => {
              this.$message.error(this.errMsg(err));
            });
        })
        .catch(() => {});
    },
    batchDelete() {
      if (!this.selected.length) return;
      this.$confirm(`确定删除选中的 ${this.selected.length} 张照片吗？`, "提示", {
        type: "warning",
      })
        .then(() => {
          this.axios({
            method: "post",
            headers: this.headers(),
            url: `https://time.api.boyalife.cn/v1/cms/ActivityAlbum/batchDelete`,
            data: { uuids: this.selected },
          })
            .then((res) => {
              this.$message.success(`已删除 ${res.data.result || this.selected.length} 张`);
              this.selected = [];
              this.getList();
              this.getCount();
            })
            .catch((err) => {
              this.$message.error(this.errMsg(err));
            });
        })
        .catch(() => {});
    },
    errMsg(err) {
      try {
        return err.response.data.error.message;
      } catch (e) {
        return typeof err === "string" ? err : "操作失败";
      }
    },
  },
};
</script>

<!--
  这里用纯 CSS 而不是 scss: 项目的 sass-loader 是 13.x(要 webpack 5), 而项目是
  webpack 4, 且 sass/node-sass 都没装。已有 .vue 靠 cache-loader 的历史缓存还能编,
  新写的 scss 一编译就报 this.getOptions is not a function。
  降级 sass-loader 会牵动所有人, 所以这个新页面绕开它。
-->
<style scoped>
.activityAlbum {
  padding: 20px;
}

.album-setting .label {
  font-size: 14px;
  color: #606266;
}

.album-count span {
  margin-right: 30px;
  font-size: 14px;
  color: #606266;
}

.album-count b {
  color: #f98004;
  font-size: 16px;
}

.album-bar {
  overflow: hidden;
}

.album-bar .fr {
  float: right;
}

.album-bar .upload-inline {
  display: inline-block;
  vertical-align: middle;
}

.album-list {
  display: flex;
  flex-wrap: wrap;
}

.album-list .album-item {
  position: relative;
  width: 180px;
  margin: 0 16px 16px 0;
  padding-bottom: 6px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  overflow: hidden;
}

.album-list .album-item.is-checked {
  border-color: #f98004;
}

.album-list .item-check {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 2;
  padding: 2px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 3px;
}

.album-list .item-img {
  display: block;
  width: 180px;
  height: 180px;
  background: #f5f7fa;
}

.album-list .item-info {
  padding: 6px 8px 0;
  font-size: 12px;
  line-height: 18px;
}

.album-list .item-info p {
  margin: 0;
}

.album-list .item-del {
  padding: 0 8px;
  color: #f56c6c;
}

.album-list .ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.qr-box {
  text-align: center;
}

.qr-box img {
  width: 260px;
  height: 260px;
}

.qr-box p {
  margin: 6px 0 0;
}
</style>
